import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrders } from "../../store/thunk/checkout";
import { isTokenExpired } from "../../Utils/Utils";
import { logOut, raiseError } from "../../store/actions/action";
import { useNavigate } from "react-router-dom";



function Orders(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const Orders = useSelector((store) => store.user.myOrders)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if(!isTokenExpired()){
            if (props.userId)
            dispatch(fetchOrders({userId:props.userId}));
        }
        else{
            dispatch(logOut);
            dispatch(raiseError("Please login again"));
            navigate('/');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="col-lg-8 col-md-8 col-12">
            <div className="ml-0 ml-md-4">
                <div className="d-none d-md-block">
                    <div className="row mb-md-5">
                        <div className="col">
                            <h5 className="mb-1 text-white">Orders</h5>
                            <p className="mb-0 text-white small">
                                You have full control to manage your own orders.
                            </p>
                        </div>
                        <div className="col-auto">
                            <a href="#" className="btn btn-primary btn-sm"> <i className="ti-angle-left"></i> Go Back</a>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="table-responsive">
                        <table className="table mb-0">
                            <thead>
                                <tr>
                                    <th>Order #</th>
                                    <th>Date Purchased</th>
                                    <th>Total</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Orders && Orders.length > 0 &&
                                    Orders.map((order) => {
                                        return (
                                            <tr key={order.id}>
                                                <td className="py-3"><a href="#" className="nav-link-style fw-medium fs-sm" data-bs-toggle="modal">{order.id}</a></td>
                                                <td className="py-3">{new Date(order.orderDate).toLocaleDateString('en-IN')}</td>
                                                <td className="py-3">₹{order.totalAmount}</td>
                                                <td className="py-3">
                                                    <span className={`badge ${order.orderStatus === 'Delivered' ? 'bg-success' : order.orderStatus === 'Cancelled' ? 'bg-danger' : 'bg-warning text-dark'}`}>
                                                        {order.orderStatus || 'Pending'}
                                                    </span>
                                                </td>
                                            </tr>
                                        );
                                    })

                                }

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Orders;